import { Box, Skeleton } from "@mui/material";
import API from "../../../api";
import React, { useState, useEffect, useRef } from "react";
import Globe from "react-globe.gl";

const GlobeH = ({ agent, lecs }) => {
  const globeEl = useRef();
  const globeContainer = useRef(null);

  const [countries, setCountries] = useState({ features: [] });
  const [transitionDuration] = useState(1000);
  const [hoverD, setHoverD] = useState();
  const [loading, setLoading] = useState(true);
  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const controller = new AbortController()
    const loadData = async () => {
      try {
        const [mapResult, geoJsonResponse] = await Promise.all([
          API.getMap(undefined, controller.signal),
          fetch("/Country.geojson", { signal: controller.signal }),
        ]);

        const geoJson = await geoJsonResponse.json();


        // =========================
        // DATI MAPPA ROSSA
        // =========================
        // Atteso formato tipo:
        // [{ _id: { countryCode: "IT" }, countIP: 10 }, ...]
        const mapByCountryCode = (mapResult.data || []).reduce((acc, item) => {
          const countryCode = item?._id?.countryCode;
          if (!countryCode) return acc;

          acc[countryCode] = {
            countIP: item.countIP || 0,
          };
          return acc;
        }, {});

        // Unisco i paesi presenti almeno in una delle due sorgenti
        const filteredCountries = geoJson.features
          .filter((feature) => {
            const isoCode = feature.properties.ISO_A2;
            return (
              mapByCountryCode.hasOwnProperty(isoCode)
            );
          })
          .map((feature) => {
            const isoCode = feature.properties.ISO_A2;

            const hasMap = mapByCountryCode.hasOwnProperty(isoCode);

            return {
              ...feature,
              properties: {
                ...feature.properties,
                mapCountIP: hasMap ? mapByCountryCode[isoCode].countIP : 0,
                source: hasMap ? "map" : "none",
              },
            };
          });

        setCountries({ features: filteredCountries });
      } catch (error) {
        if (error.name !== 'AbortError' && error.name !== 'CanceledError') {
          console.error("[loadData] Si è verificato un errore durante il recupero dei dati:", error.message);
        }
      } finally {
        setLoading(false);
      }
    };

    loadData();
    return () => controller.abort()
  }, []);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setDimensions({
          width: Math.floor(entry.contentRect.width),
          height: Math.floor(entry.contentRect.height),
        });
      }
    });

    if (globeContainer.current) {
      resizeObserver.observe(globeContainer.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!globeEl.current || !dimensions.width || !dimensions.height) return;

    const controls = globeEl.current.controls();
    controls.autoRotate = true;
    controls.autoRotateSpeed = 3;
    controls.enableZoom = false;
  }, [dimensions.width, dimensions.height, countries]);

  const getPolygonColor = (feature) => {
    const source = feature?.properties?.source;

    // solo getMap -> rosso
    if (source === "map") {
      return feature === hoverD
        ? "rgba(255, 120, 120, 0.95)"
        : "rgba(220, 30, 30, 0.75)";
    }

    return "rgba(200, 200, 200, 0.4)";
  };

  const getPolygonAltitude = (feature) => {
    if (feature === hoverD) return 0.15;

    return 0.05;
  };

  return (
    <Box className="miniMap" height="100%" width="100%">
      {loading && (
        <Skeleton
          variant="rounded"
          width="100%"
          height="100%"
          sx={{ bgcolor: "rgba(255,255,255,0.06)", borderRadius: 2, minHeight: 200 }}
        />
      )}
      <div ref={globeContainer} style={{ width: "100%", height: loading ? 0 : "100%", overflow: "hidden" }}>
        {!loading && dimensions.width > 0 && dimensions.height > 0 && (
          <Globe
            ref={globeEl}
            height={dimensions.height}
            width={dimensions.width}
            globeImageUrl="/earth-blue-marble.jpg"
            backgroundImageUrl="/night-sky.png"
            bumpImageUrl="/earth-topology.png"
            polygonsData={countries.features}
            polygonAltitude={getPolygonAltitude}
            polygonCapColor={getPolygonColor}
            polygonSideColor={() => {
              return "rgba(120, 0, 0, 0.35)";
            }}
            polygonStrokeColor={() => {
              return "rgba(255, 120, 120, 0.7)";
            }}
            polygonLabel={({ properties: d }) => `
              <div style="
                background-color: #162342;
                border-radius: 4px;
                padding: 8px;
                font-size: 12px;
                color: #fff;
                text-align: left;
                min-width: 140px;
              ">
                <b>${d.ADMIN}</b><br />
                Lecs IP: <i>${d.mapCountIP || 0}</i><br />
              </div>
            `}
            polygonsTransitionDuration={transitionDuration}
            onPolygonHover={setHoverD}
            onPolygonClick={(d) => {
              window.sessionStorage.setItem("selectedTab", "Map");

              window.location.href =
                window.sessionStorage.getItem("type") === "user"
                  ? `/user/extra/map?country=${d.properties.ADMIN}&countryCode=${d.properties.ISO_A2}`
                  : `/reseller/myC/extra/map?country=${d.properties.ADMIN}&countryCode=${d.properties.ISO_A2}`;
            }}
          />
        )}
      </div>
    </Box>
  );
};

export default GlobeH;